import React, { useState } from 'react';
import { MessageCircle, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function LiveChatButton() {
  const [isHovered, setIsHovered] = useState(false);
  return <motion.button initial={{
    scale: 0,
    opacity: 0
  }} animate={{
    scale: 1,
    opacity: 1
  }} transition={{
    delay: 1,
    duration: 0.3
  }} onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)} className="fixed bottom-6 right-6 z-50 group" aria-label="Open live chat" data-id="element-435">
      {/* Main Button */}
      <div className="relative" data-id="element-436">
        <div className="w-16 h-16 sm:w-24 sm:h-24 bg-gradient-to-br from-brand-purple-600 to-brand-purple-700 rounded-full shadow-2xl flex flex-col items-center justify-center text-white transition-all duration-300 hover:scale-110 hover:shadow-brand-purple-300/50 border-4 border-white" data-id="element-437">
          {/* Pulse Animation */}
          <motion.div className="absolute inset-0 rounded-full bg-brand-purple-400" animate={{
          scale: [1, 1.2, 1],
          opacity: [0.5, 0, 0.5]
        }} transition={{
          duration: 2,
          repeat: Infinity,
          ease: 'easeInOut'
        }} data-id="element-438" />

          {/* Icon */}
          <MessageCircle className="w-6 h-6 sm:w-10 sm:h-10 mb-0.5 sm:mb-1 relative z-10" strokeWidth={2.5} data-id="element-439" />

          {/* Text */}
          <div className="text-[8px] sm:text-[10px] font-bold leading-tight text-center relative z-10" data-id="element-440">
            <div data-id="element-441">LIVE CHAT</div>
            <div className="text-brand-orange-300" data-id="element-442">24/7</div>
          </div>
        </div>

        {/* Online Indicator Dot */}
        <div className="absolute top-1 right-1 w-4 h-4 bg-green-400 rounded-full border-2 border-white shadow-lg" data-id="element-443">
          <motion.div className="w-full h-full bg-green-400 rounded-full" animate={{
          scale: [1, 1.3, 1],
          opacity: [1, 0.5, 1]
        }} transition={{
          duration: 1.5,
          repeat: Infinity,
          ease: 'easeInOut'
        }} data-id="element-444" />
        </div>
      </div>

      {/* Hover Tooltip */}
      <AnimatePresence data-id="element-445">
        {isHovered && <motion.div initial={{
        opacity: 0,
        x: 10
      }} animate={{
        opacity: 1,
        x: 0
      }} exit={{
        opacity: 0,
        x: 10
      }} className="absolute right-28 top-1/2 -translate-y-1/2 bg-gray-900 text-white px-4 py-2 rounded-lg shadow-xl whitespace-nowrap text-sm font-medium" data-id="element-446">
            Need help? Chat with us!
            <div className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-1/2 rotate-45 w-2 h-2 bg-gray-900" data-id="element-447"></div>
          </motion.div>}
      </AnimatePresence>
    </motion.button>;
}